export function simplify(inputGeometry, tolerance = 0.15) {
    const verticesMap = {}; // Map to store unique vertices
    const indexAttribute = inputGeometry.getIndex();
    const positionAttribute = inputGeometry.getAttribute('position');
    const indexCount = indexAttribute
        ? indexAttribute.count
        : positionAttribute.count;
    let uniqueVertexCount = 0;
    const newIndices = []; // Array to store new indices
    const newPositions = []; // Array to store new positions

    const logTolerance = Math.log10(1 / tolerance);
    const toleranceMultiplier = Math.pow(10, logTolerance);

    for (let i = 0; i < indexCount; i++) {
        const vertexIndex = indexAttribute ? indexAttribute.getX(i) : i;
        let vertexKey = '';

        // Generate a unique key for each vertex using its rounded position
        vertexKey +=
            ~~(positionAttribute.getX(vertexIndex) * toleranceMultiplier) + ',';
        vertexKey +=
            ~~(positionAttribute.getY(vertexIndex) * toleranceMultiplier) + ',';
        vertexKey +=
            ~~(positionAttribute.getZ(vertexIndex) * toleranceMultiplier) + ',';

        // If the vertex key is not in the verticesMap, add the vertex to newPositions and store its index in verticesMap
        if (!(vertexKey in verticesMap)) {
            newPositions.push(positionAttribute.getX(vertexIndex));
            newPositions.push(positionAttribute.getY(vertexIndex));
            newPositions.push(positionAttribute.getZ(vertexIndex));
            verticesMap[vertexKey] = uniqueVertexCount;
            uniqueVertexCount++;
        }
        // Add the index of the vertex in newPositions to newIndices
        newIndices.push(verticesMap[vertexKey]);
    }

    // Create a new BufferAttribute with the simplified positions
    const newPositionAttribute = new THREE.BufferAttribute(
        new Float32Array(newPositions),
        positionAttribute.itemSize,
        positionAttribute.normalized
    );

    // Create a new BufferGeometry and set its position attribute and indices
    const simplifiedGeometry = new THREE.BufferGeometry();
    simplifiedGeometry.setAttribute('position', newPositionAttribute);
    simplifiedGeometry.setIndex(newIndices);

    return simplifiedGeometry;
}
